import { PureComponent } from "react";

import { BTUserGroup } from "commonComponents/btWrappers/BTUserGroup/BTUserGroup";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

interface IUser {
    globalUserId: number;
    displayName: string;
}

type ISelectUserCellResponse = IUser[] | undefined;

class SelectUserCell extends PureComponent<IGridCellRenderProps<ISelectUserCellResponse>> {
    render() {
        const { cellValue } = this.props;

        if (!cellValue) {
            return null;
        }

        return <BTUserGroup size="small" data={cellValue} />;
    }
}

export const columnSelectUser: IClientGridColumn<ISelectUserCellResponse> = {
    columnType: GridColumnType.selectUser,
    Cell: SelectUserCell,
};
